import { useMutation } from "react-query";
import { addSingleOfficeKeys } from "../../../../actions/CarrierAgreementMgmt/Security";

const useAddSingleOfficeKeys = () => {
  return useMutation(addSingleOfficeKeys);
};
export default useAddSingleOfficeKeys;
